import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from './services/api';

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [haircuts, setHaircuts] = useState([]);
  const [clients, setClients] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Функция для загрузки всех данных
  const loadAllData = async () => {
    const token = localStorage.getItem('token');
    
    if (!token) {
      console.warn('⚠️ Токен не найден — данные не загружены');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Загружаем все данные параллельно
      const [haircutsRes, clientsRes, expensesRes] = await Promise.all([
        api.getHaircuts({ search: '' }),
        api.getClients(),
        api.getExpenses({ search: '' }),
      ]);

      setHaircuts(haircutsRes.data);
      setClients(clientsRes.data);
      setExpenses(expensesRes.data);
      
      console.log('✅ Данные успешно загружены и закешированы');
      console.log('Haircuts:', haircutsRes.data.length);
      console.log('Clients:', clientsRes.data.length);
      console.log('Expenses:', expensesRes.data.length);
    } catch (err) {
      console.error('❌ Ошибка загрузки данных:', err.response?.data || err.message);
      setError(err.response?.data?.message || 'Ошибка загрузки данных');
    } finally {
      setLoading(false);
    }
  };

  // Загружаем данные при монтировании
  useEffect(() => {
    loadAllData();
  }, []);

  // Функция для обновления списка стрижек
  const refreshHaircuts = async () => {
    try {
      const response = await api.getHaircuts({ search: '' });
      setHaircuts(response.data);
    } catch (err) {
      console.error('Ошибка обновления стрижек:', err);
    }
  };

  // Функция для обновления списка клиентов
  const refreshClients = async () => {
    try {
      const response = await api.getClients();
      setClients(response.data);
    } catch (err) {
      console.error('Ошибка обновления клиентов:', err);
    }
  };

  // Функция для обновления списка расходов
  const refreshExpenses = async () => {
    try {
      const response = await api.getExpenses({ search: '' });
      setExpenses(response.data);
    } catch (err) {
      console.error('Ошибка обновления расходов:', err);
    }
  };

  // Функция для добавления новой стрижки
  const addHaircut = (newHaircut) => {
    setHaircuts(prev => [newHaircut, ...prev]);
  };

  // Функция для добавления нового клиента
  const addClient = (newClient) => {
    setClients(prev => [newClient, ...prev]);
  };

  // Функция для добавления нового расхода
  const addExpense = (newExpense) => {
    setExpenses(prev => [newExpense, ...prev]);
  };

  return (
    <DataContext.Provider
      value={{
        // Данные
        haircuts,
        clients,
        expenses,
        loading,
        error,
        
        // Сеттеры
        setHaircuts,
        setClients,
        setExpenses,
        
        // Функции обновления
        refreshHaircuts,
        refreshClients,
        refreshExpenses,
        loadAllData,
        
        // Функции добавления
        addHaircut,
        addClient,
        addExpense,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData должен использоваться внутри DataProvider');
  }
  return context;
};